module.exports = __webpack_public_path__ + "media/images/icons/Hand, Arm, Heart-bc4d3bd5e5c305551cc8691cccad65e6.svg";